<template>
  <div class="in-stock-card__bottom">
    <p class="in-stock-card__info">{{ title1 }} <br> {{ title5 }} {{ minQuantity }} {{ title2 }}</p>
    <div class="in-stock-card__quantity quantity">
      <button type="button" class="quantity__link quantity__link--minus" @click="quantityMinus()"></button>
      <input class="quantity__control" type="text" v-model="quantity" :min="minQuantity" :max="maxQuantity"
             :step="stepQuantity" @change="quantityChange" @input="quantityInput">
      <button type="button" class="quantity__link quantity__link--plus" @click="quantityPlus()"></button>
    </div>
    <div class="in-stock-card__btn">
      <span v-if="productInCart(productId)" class="added-confirm">{{ title3 }}</span>
      <button v-else type="button" class="add-to-cart" @click="addToCartPrev({productId, quantity})">{{ title4 }}
      </button>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "AddToCart",
  props: {
    productId: Number,
    minQuantity: Number,
    maxQuantity: Number,
    stepQuantity: Number,
    params: String,
    title1: {
      type: [String],
      default: BX.message('CATALOG_ADD_TO_CART_1')
    },
    title2: {
      type: [String],
      default: BX.message('CATALOG_ADD_TO_CART_2')
    },
    title3: {
      type: [String],
      default: BX.message('CATALOG_ADD_TO_CART_3')
    },
    title4: {
      type: [String],
      default: BX.message('CATALOG_ADD_TO_CART_4')
    },
    title5: {
      type: [String],
      default: BX.message('CATALOG_ADD_TO_CART_5')
    },
  },
  data() {
    return {
      quantity: this.minQuantity,
    };
  },
  computed: {
    ...mapGetters('moduleCart', {
      productInCart: 'productInCart',
      cartItemByProductId: 'cartItemByProductId',
    })
  },
  mounted() {
    setTimeout(() => {
      if (this.productInCart(this.productId)) {
        let cartItem = this.cartItemByProductId(this.productId);
        this.quantity = cartItem.quantity;
      }
    }, 500);
  },
  methods: {
    ...mapActions('moduleCart', {
      addToCart: 'add',
      setQuantity: 'quantity',
    }),
    quantityChange(event) {
      if (parseInt(event.target.value) > this.maxQuantity)
        this.quantity = this.maxQuantity;
      else if (event.target.value === '' || parseInt(event.target.value) < this.minQuantity)
        this.quantity = this.minQuantity;
      else if (event.target.value !== '')
        this.quantity = Number(event.target.value);

      this.quantityUpdate();
    },
    quantityInput(event) {
      if (event.target.value !== '' && !Number(event.target.value))
        this.quantity = this.minQuantity;

      this.quantityUpdate();
    },
    quantityPlus() {
      let tempQuantity;

      if (this.quantity % this.stepQuantity === 0) {
        tempQuantity = this.stepQuantity * (this.quantity/this.stepQuantity + 1);
      } else {
        tempQuantity = this.stepQuantity * Math.ceil(this.quantity/this.stepQuantity);
      }

      if (tempQuantity < this.maxQuantity) {
        this.quantity = tempQuantity;
        this.quantityUpdate();
      } else {
        this.quantity = this.maxQuantity;
        this.quantityUpdate();
      }
    },
    quantityMinus() {
      let tempQuantity;

      if (this.quantity % this.stepQuantity === 0) {
        tempQuantity = this.stepQuantity * (this.quantity/this.stepQuantity - 1);
      } else {
        tempQuantity = this.stepQuantity * Math.floor(this.quantity/this.stepQuantity);
      }

      if (tempQuantity > this.minQuantity) {
        this.quantity = tempQuantity;
        this.quantityUpdate();
      } else {
        this.quantity = this.minQuantity;
        this.quantityUpdate();
      }
    },
    quantityUpdate() {
      if (this.productInCart(this.productId)) {
        let cartItem = this.cartItemByProductId(this.productId);
        let cartId = cartItem.id;
        let quantity = this.quantity;
        this.setQuantity({cartId, quantity});
      }
    },
    async addToCartPrev({productId, quantity}) {
      if (quantity === 0) {
        window.toast.error('Ошибка добавления в корзину', 'Товара нет в наличии');
        return false;
      }

      let _tmr = window._tmr || (window._tmr = []);
      _tmr.push({ type: 'reachGoal', id: 3352405, goal: 'add_to_order'});

      let params = this.params;

      this.addToCart({productId, quantity, params});
    },
  }
}
</script>